//
//
//
//
//
//
//
//
//
//
//
//

import lessonItem from "../../components/common/lessonitem";
import force from "../../common/forceLandscape";
  export default {
      name: "test",
    components:{
        lessonItem
    },
    data(){
        return {
          itemData:[
            {
              title:'Test1',
              content:this.$store.state.title['lv'+this.$store.state.testLevel][0],
              imgsrc:'/static/images/icon1@2x.png',
              bgsrc:'/static/images/kuang1@2x.png',
              path:this.$store.state.tixing['lv'+this.$store.state.testLevel][0],
            },
            {
              title:'Test2',
              content:this.$store.state.title['lv'+this.$store.state.testLevel][1],
              imgsrc:'/static/images/icon1@2x.png',
              bgsrc:'/static/images/kuang2@2x.png',
              path:this.$store.state.tixing['lv'+this.$store.state.testLevel][1]
            },
            {
              title:'Test3',
              content:this.$store.state.title['lv'+this.$store.state.testLevel][2],
              imgsrc:'/static/images/icon1@2x.png',
              bgsrc:'/static/images/kuang3@2x.png',
              path:this.$store.state.tixing['lv'+this.$store.state.testLevel][2]
            },
          ],
          bodyStyle:{
            width:0,
            height:0,
            fontSize:0
          }
        }
    },
    created() {

        this.$store.commit('reset');
        // this.bodyStyle.width=window.innerHeight+'px';
        // this.bodyStyle.height=window.innerWidth+'px';
        // this.bodyStyle.fontSize=window.innerHeight/(375/16)+'px';
    },
    mounted() {
      console.log(111);
      force();  //强制横屏
    }
  }



// WEBPACK FOOTER //
// ./src/components/test/test.vue